/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export class GracePeriodUtils {
    private static TAG: string = 'GracePeriodUtils';

    private static mGracePeriodUtils: GracePeriodUtils;

    private consumedGracePeriod: number;

    private constructor() {
        this.consumedGracePeriod = 0;
    }

    public static getInstance(): GracePeriodUtils {
        if (!GracePeriodUtils.mGracePeriodUtils) {
            GracePeriodUtils.mGracePeriodUtils = new GracePeriodUtils();
        }
        return GracePeriodUtils.mGracePeriodUtils;
    }

    public setConsumedGracePeriod(time: number): void {
        this.consumedGracePeriod = time;
    }

    public getConsumedGracePeriod(): number {
        return this.consumedGracePeriod;
    }
}
